// extracted by css-extract-rspack-plugin
export default {"skeleton":"RCvlsmlnvLMjdEyH","skeleton-animation":"QhmRiFfuxmEJQqM8"};